import React, { Component } from "react";
import ApexCharts from 'apexcharts'

export default class CategoryReponseChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			chart: ''
		}
	}

	componentDidMount = () => {
		this.load();
	}

	load = () => {
		var options = {
			series: [{
				name: "Breach Time",
				data: this.props.categoryResponce['breachTime']? this.props.categoryResponce['breachTime']: []
			}, {
				name: "Incident Time",
				data: this.props.categoryResponce['incidentTime']? this.props.categoryResponce['incidentTime']: []
			}],
			chart: {
				height: 350,
				type: 'bar'
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: 'smooth'
			},
			xaxis: {
				type: 'text',
				labels: {
					show: false
				},
				categories: this.props.categoryResponce['category']? this.props.categoryResponce['category']: [],
			},
			tooltip: {
                enabled: true,
                style: {
                    backgroud: 'white',
                    fontSize: '12px',
                    fontFamily: undefined
                },
                y: {
                    formatter: (value) => { return value + " Seconds" },
                }
            },
		}
		
		var chart = new ApexCharts(document.querySelector("#categoryChart"), options);
		if(chart) chart.render();
		this.setState({ chart: chart });
	}

	componentDidUpdate = (prevProps) => {
		if(this.props.categoryResponce !== prevProps.categoryResponce){
			if(this.state.chart) this.state.chart.destroy();
			this.load();
		}
	}

	render() {
		return (
			<div id="categoryChart"></div>
		);
	}
}